const COLORS = {
  black: '#10111a',
  gray70: '#424a51',
  gray60: '#616970',
  gray50: '#8d9ba1',
  gray40: '#ccd1d7',
  gray30: '#d8dde1',
  gray20: '#eceff4',
  gray10: '#f6f7f8',
  white: '#fff',
  primary: '#1185ed',
  primaryDark: '#0e70c8',
  accent: '#00efd2',
  danger: '#e61e39',
  danger10: '#fdedef',
  success: '#4cc863',
  success10: '#edfcef',
  warning: '#ffa035',
  warning10: '#fff5eb',
  info: '#3fb9f7',
  info10: '#ebf8ff',
};
export default COLORS;
